/* global Flipping */
const elPrevButton = document.querySelector('#person-prev')
const elNextButton = document.querySelector('#person-next')
let flipping = new Flipping()
const elImages = Array.from(document.querySelectorAll('.top-personSlide__bigImage'))
const elThumbnails = Array.from(document.querySelectorAll('.top-personSlide__thumbnail'))

let state = {
  photo: 0
}

function send(event) {
  // read cuticle positions
  flipping.read()

  const elActives = document.querySelectorAll('[data-active]')

  for (let index = 0; index < Array.from(elActives).length; index++) {
    const el = elActives[index]
    el.removeAttribute('data-active')
  }

  switch (event) {
    case 'PREV':
      state.photo--
      // Math.max(state.photo - 1, 0);
      break
    case 'NEXT':
      state.photo++
      // Math.min(state.photo + 1, elImages.length - 1);
      break
    default:
      state.photo = +event
      break
  }

  var len = elImages.length
  // Loop Around
  //state.photo = ( ( state.photo % len) + len ) % len;
  state.photo = Math.max(0, Math.min(state.photo, len - 1))

  for (let index = 0; index < Array.from(document.querySelectorAll(`[data-key="${state.photo}"]`)).length; index++) {
    const el = Array.from(document.querySelectorAll(`[data-key="${state.photo}"]`))[index]
    el.setAttribute('data-active', true)
  }

  // execute the FLIP animation
  flipping.flip()
}

if (document.getElementById('top-personSlide')) {
  for (let index = 0; index < elThumbnails.length; index++) {
    const thumb = elThumbnails[index]
    thumb.addEventListener('click', () => {
      send(thumb.dataset.key)
    })
  }

  elPrevButton.addEventListener('click', () => {
    send('PREV')
  })

  elNextButton.addEventListener('click', () => {
    send('NEXT')
  })
  send(0)
}
